<template>
  <div class="app-container exam-list">
    <div class="exam-list-filter">
      <el-row>
        <el-col :span="6">
          <el-input class="exam-list-filter-value" v-model.trim="search.title" 
            @keyup.enter.native="searchChange" placeholder="考试名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
        </el-col>
        <el-col :span="6">
          <el-input class="exam-list-filter-value" v-model.trim="search.username" 
            @keyup.enter.native="searchChange" placeholder="创建人" clearable size="small" suffix-icon="el-icon-search"></el-input>
        </el-col>
        <el-col :span="6">
          <el-select class="exam-list-filter-value" placeholder="状态" v-model="search.status" clearable size="small">
            <el-option
              v-for="item in examStatusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select class="exam-list-filter-value" placeholder="类型" v-model="search.category" clearable size="small">
            <el-option
              v-for="item in examCategoryOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="vote-list-filter-date"
              v-model="time"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small"
              @change="queryTimeChange"
              placeholder="考试时间">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6"></el-col>
        <el-col :span="6">
          <div>
            <el-button class="exam-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="exam-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container class = "exam-list-container">
      <avue-crud
          ref="crud"
          :option="tableOption"
          :data="tableData"
          :page="page"
          :table-loading="tableLoading"
          :before-open="handleOpenBefore"
          @refresh-change="getData"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange">

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.exam_add">创建考试</el-button>
        </template>
        <template slot="examInfoUrl" slot-scope="scope">
          <el-button type="text" @click="previewImg(scope.row)">
            <div>modules/exam/{{scope.row.id}}</div>
          </el-button>
        </template>
        <template slot-scope="scope"
          slot="menu">
          <el-button size="mini"
            type="text"
            icon="el-icon-view"
            @click="handleView(scope.row,scope.index)">查看
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-upload2"
                v-if="permissions.exam_edit && scope.row.status === examStatusMap.NO_PUBLISHED.name"
                @click="handleUp(scope.row,scope.index)">上架
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-download"
                v-if="permissions.exam_edit && canAbort(scope.row.status)"
                @click="handleDown(scope.row,scope.index)">终止考试
          </el-button>
          <el-button type="text"
            v-if="permissions.exam_edit && scope.row.status === examStatusMap.NO_PUBLISHED.name"
            icon="el-icon-edit"
            size="mini"
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.exam_del && (scope.row.status === examStatusMap.NO_PUBLISHED.name || scope.row.status === examStatusMap.ABORTED.name)"
            icon="el-icon-delete"
            size="mini"
            @click="handleDelete(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
     <el-dialog
      title="考试详情"
      :visible.sync="imgDialogVisible"
      fullscreen
      custom-class="preview-img-dialog">
      <div @click="imgDialogVisible = false">
        <vue-qr :text="previewImgUrl" :size="qrCodeSize"></vue-qr>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import { getExamList, deleteExam, abortExam, publishExam } from '@/api/app/exam'
import { examTableOption, examStatusOption, examCategoryOption, examStatusMap } from '@/const/crud/app/exam'
import { mapGetters } from 'vuex'

export default {
  name: 'exam',
  data() {
    return {
      tableOption: examTableOption,
      examStatusOption,
      examStatusMap,
      imgDialogVisible: false,
      previewImgUrl: '',
      qrCodeSize: 300,
      time: [],
      search: {
        current: 1,
        size: 10,
        title: '',
        username: '',
        status: '',
        category: '',
        startedTime: '',
        endedTime: '',
      },
      // 列表页面
      tableData:[],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条,
      },
      tableLoading: false,
    }
  },
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  activated() {
    this.getList();
  },
  methods: {
    queryTimeChange(value) {
      this.search.startedTime = value[0];
      this.search.endedTime = value[1];
    },
    getList() {
      let params = {
        current: this.search.current,
        size: this.search.size
      }

      if (this.search.title != "" && this.search.title.trim() != "") {
        params.title = this.search.title
      }
      if (this.search.username != "" && this.search.username.trim() != "") {
        params.username = this.search.username
      }
      if (this.search.status != "") {
        params.status = this.search.status
      }
      if (this.search.category != "") {
        params.category = this.search.category
      }
      if (!this.validatenull(this.search.startedTime)) {
        params.startedTime = this.search.startedTime
      }

       if (!this.validatenull(this.search.endedTime)) {
        params.endedTime = this.search.endedTime
      }
      
      this.tableLoading = true
      if (this.validParams(params)) {
        getExamList(params).then(response => {
          this.tableData = response.data.data.records;
          this.tableData.forEach(record => {
            record.status = (examStatusOption.find((v) => (v.value == record.status)) ? examStatusOption.find((v) => (v.value == record.status)).label :'类型异常');
            record.category = (examStatusOption.find((v) => (v.value == record.category)) ? examCategoryOption.find((v) => (v.value == record.category)).label :'--');
            record.duration = record.duration === 0 ? '不限时' : Math.floor(record.duration / 60) + '分钟';
          })
          this.page.total = response.data.data.total
          this.tableLoading = false
        }).catch(error => {
          console.error(error)
          this.$message({
            message: '获取考试列表失败',
            type: 'error'
          })
          this.tableLoading = false;
        })
      }
    },
     validParams(params) {
      if (params.username && params.username.length < 2) {
        this.$message({
          message: '创建人至少输入两个字符',
          type: 'error'
        })
        return false;
      } 
      return true;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.search.current = val
      this.getList()
    },
    handleSizeChange(val) {
      this.page.pageSize = val
      this.search.size = val
      this.getList()
    },
    initPage() {
      this.page.currentPage = 1
      this.page.pageSize = this.search.size
      this.search.current = 1
    },
    searchChange() {
      this.initPage()
      this.getList()
    },
    searchReset() {
      this.search.title = '',
      this.search.username = '',
      this.search.status = '',
      this.search.category = '',
      this.search.startedTime = '',
      this.search.endedTime = '',
      this.time = []
      this.searchChange()
    },
    handleAdd: function() {
      this.$router.push({
        path: '/app/exam/exam/add'
      })
    },
    handleEdit(row, index) {
      this.$router.push({
        path: `/app/exam/exam/edit/${row.id}`,
      })
    },
    handleView(row, index) {
      this.$router.push({
        path: `/app/exam/exam/detail/${row.id}`,
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteExam(row.id).then(response => {
          if (response.data.data) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList()
          }
        }).catch(error => {
          this.$message({
            message: '删除失败',
            type: 'error'
          })
        })
      })
    },
    handleUp(row, index) {
      // 发布功能
      let _this = this
      this.$confirm('是否确认发布该考试，发布后将无法修改考试信息?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return publishExam(row.id);
      }).then(() => {
        this.getList()
        _this.$message({
          showClose: true,
          message: '发布成功',
          type: 'success'
        })
      }).catch(function () {
      })
    },
    canAbort(status) {
      if (status !== examStatusMap.NO_PUBLISHED.name && status !== examStatusMap.ENDED.name && status !== examStatusMap.ABORTED.name) {
        return true;
      }
      return false;
    },
    handleDown(row, index) {
      let _this = this
      this.$confirm('是否确认终止该考试，此操作将会提前结束该考试，仅在考试出现问题是使用?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return abortExam(row.id);
      }).then(() => {
        this.getList()
        _this.$message({
          showClose: true,
          message: '终止成功',
          type: 'success'
        })
      }).catch(function () {
      })
    },
    previewImg(row) {
      if (row.status === examStatusOption[0].label) {
        this.$message({
          type: 'error',
          message: '请发布考试后，再查看考试详情链接'
        })
      } else {
        this.previewImgUrl = row.examInfoUrl;
        this.imgDialogVisible = true;
      }
 
    },
  },
}
</script>

<style lang="scss" scoped>

.exam-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
  /deep/ .el-dialog.preview-img-dialog{
    background: rgba(0, 0, 0, 0.5);
    .el-dialog__header {
      padding: 0;
      .el-dialog__headerbtn {
        top: 40px;
        right: 40px;
        .el-dialog__close {
          font-size: 20px;
          color: #fff;
          font-weight: bold;
          border: 2px solid #fff;
          border-radius: 50%;
          padding: 5px;
        }
      }
    }
    .el-dialog__body {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0;
      img {
        max-height: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>
